const API_BASE = import.meta.env.VITE_API_URL || 'https://mazakertesh-api.mazakerteshleh-support.workers.dev'

function getHeaders(): HeadersInit {
  const token = localStorage.getItem('mazakertesh_token')
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {})
  }
}

function handleUnauthorized() {
  localStorage.removeItem('mazakertesh_token')
  localStorage.removeItem('mazakertesh_user')
  window.location.href = '/login'
}

async function handleResponse(res: Response) {
  if (res.status === 401) {
    handleUnauthorized()
    throw new Error('Session expired. Please login again.')
  }
  if (!res.ok) {
    const text = await res.text()
    let err = text
    try {
      const json = JSON.parse(text)
      err = json.error || text
    } catch { /* not json */ }
    throw new Error(err)
  }
  return res.json()
}

export async function apiGet(endpoint: string) {
  const res = await fetch(`${API_BASE}${endpoint}`, { headers: getHeaders() })
  return handleResponse(res)
}

export async function apiPost(endpoint: string, body: any) {
  const res = await fetch(`${API_BASE}${endpoint}`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(body)
  })
  return handleResponse(res)
}

export async function apiPut(endpoint: string, body: any) {
  const res = await fetch(`${API_BASE}${endpoint}`, {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify(body)
  })
  return handleResponse(res)
}

export async function apiDelete(endpoint: string) {
  const res = await fetch(`${API_BASE}${endpoint}`, {
    method: 'DELETE',
    headers: getHeaders()
  })
  return handleResponse(res)
}

// AI Services
export async function askAI(question: string, context?: string) {
  return apiPost('/ai/ask', { question, context })
}

export async function generateQuiz(topic: string, difficulty: string) {
  return apiPost('/ai/generate-quiz', { topic, difficulty })
}

export async function gradeWithAI(answer: string, question: string, rubric: string) {
  return apiPost('/ai/grade', { answer, question, rubric })
}

// Google Meet
export async function createMeeting(title: string, scheduledAt: string) {
  return apiPost('/meetings/create', { title, scheduledAt })
}

export async function getMeetingLink(meetingId: string) {
  return apiGet(`/meetings/${meetingId}/link`)
}